// import: styles
import { Box, Modal } from '@mui/material';

// import: assets
import { ReactComponent as Cross } from 'core/assets/svg/common/cross.svg';

// import: components
import BaseButton from 'core/components/button/BaseButton';
import BaseImage from 'core/components/image/BaseImage';
import {
	marketingPopUpStyles,
	PopUp,
} from 'core/layouts/components/marketing/marketing-pop-up/MarketingPopUpStyles';

// import: constants
// import: utils
// import: services
// import: redux
import {
	openMarketingPopUpSelector,
	toggleOpenMarketingPopUp,
} from 'core/store/reducers/appReducer/AppSlice';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import: lazy load components

function MarketingPopUp() {
	const dispatch = useDispatch();

	const open = useSelector(openMarketingPopUpSelector);
	const handleClose = () => dispatch(toggleOpenMarketingPopUp(false));

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="challenge"
			aria-describedby="claim free credits"
		>
			<Box id="modal-wrapper" sx={marketingPopUpStyles.modalWrapper} onClick={() => handleClose()}>
				<Box id="modal-body" sx={marketingPopUpStyles.modalBody}>
					<Box
						id="halloween-art-challenge-pop-up"
						sx={[marketingPopUpStyles.MarketingPopUp]}
						onClick={(e) => e.stopPropagation()}
					>
						<BaseButton
							id="cross-button"
							onClick={(e) => {
								e.stopPropagation();
								handleClose();
							}}
							styles={[marketingPopUpStyles.crossButton]}
						>
							<Cross id="cross-icon" />
						</BaseButton>

						<BaseImage src={PopUp} alt="" />
					</Box>
				</Box>
			</Box>
		</Modal>
	);
}

export default MarketingPopUp;
